import BaseCrudService from "./baseCrud.service";
import { Routes } from "@/scripts/models/enums/routes.enum.js";

export default class UserCompanyConsentTermService extends BaseCrudService {

    constructor() {
        super('UserCompanyConsentTerm');
    }

    save(userCompanyConsentTerm) {
        return this.postRequest('Save', userCompanyConsentTerm);
    }

}